import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router";
import { trpc } from "../../app/trpc.js";
import { Notice, Spinner } from "../../ui/index.js";
import { NOTICE } from "./notice.js";
import { PublicShell, usePublicLocale } from "./PublicShell.js";

/** `/data-notice/:slug`: уведомление о данных для клиентов салона (ссылка для шапки профиля). Черновик до проверки юристом. */
export function DataNoticePage() {
  const { t, i18n } = useTranslation();
  const { slug = "" } = useParams();
  const salon = useQuery(trpc.onboarding.public.notice.queryOptions({ slug }, { retry: false }));
  usePublicLocale(salon.data?.locale);
  if (salon.isPending) return <Spinner />;
  if (!salon.data)
    return (
      <PublicShell>
        <Notice kind="error">{t("book.notFound")}</Notice>
      </PublicShell>
    );
  const text = NOTICE[i18n.language.startsWith("sr") ? "sr" : "en"];
  const name = salon.data.name;
  return (
    <PublicShell salonName={name} slug={salon.data.slug}>
      <h1 className="mb-3 text-2xl font-semibold text-ink">{text.title}</h1>
      <Notice kind="warning">{text.draft}</Notice>
      <p className="mt-4 text-ink-2">{text.intro(name)}</p>
      {text.sections(name).map((s) => (
        <section key={s.heading} className="mt-5">
          <h2 className="mb-1 font-semibold text-ink">{s.heading}</h2>
          {s.paragraphs?.map((p) => (
            <p key={p} className="text-sm text-ink-2">
              {p}
            </p>
          ))}
          {s.list && (
            <ul className="list-disc space-y-1 pl-5 text-sm text-ink-2">
              {s.list.map((li) => (
                <li key={li}>{li}</li>
              ))}
            </ul>
          )}
        </section>
      ))}
      <Link to="/privacy" className="mt-6 inline-block text-sm font-medium text-brand underline-offset-2 hover:underline">
        {text.privacyLink}
      </Link>
    </PublicShell>
  );
}
